'use strict';
var ClinicalUpdatesElementsController = /** @class */ (function () {
    /*@ngInject*/
    function ClinicalUpdatesElementsController(ClinicalUpdatesElementService, $scope, $timeout, $sce) {
        var _this = this;
        this.downloadPDF = function (fileId) {
            var downloadUrl = "api/content/resourceContentFile/" + fileId + "/download";
            return downloadUrl;
        };
        $scope.vm.isHeroTabs = false;
        var data;
        var numbers;
        var jsonData;
        var year;
        var years = [];
        var fileId = [];
        var fileName = [];
        var yearWiseData = {};
        var yearWiseDataArray = [];
        this._$sce = $sce;
        this.ClinicalUpdatesElementService = ClinicalUpdatesElementService;
        this.timeout = $timeout;
        this.currentPageIndex = 1;
        ClinicalUpdatesElementService.getClinicalUpdatesElementData(this.currentPageIndex)
            .then(function (response) {
            var resp = response;
            _this.data_colomn = resp.currentPage;
            data = _this.data_colomn;
            for (var i = 0; i < data.length; i++) {
                year = data[i].fileName.split("#");
                fileName.push(year[1]);
                if (years.length == 0) {
                    years.push(year[0]);
                }
                else {
                    if (!~years.indexOf(year[0])) {
                        years.push(year[0]);
                    }
                }
            }
            for (var j = 0; j < years.length; j++) {
                yearWiseData = new Object();
                var contentArray = [];
                var contentJson = {};
                yearWiseData["year"] = years[j];
                for (var k = 0; k < data.length; k++) {
                    numbers = data[k].downloadUrl.split(/\//)[5];
                    jsonData = data[k].fileName.split("#");
                    if (years[j] == jsonData[0]) {
                        contentJson = new Object();
                        contentJson["name"] = data[k].subject;
                        contentJson["fileId"] = numbers;
                        if (!~contentArray.indexOf(contentJson)) {
                            contentArray.push(contentJson);
                        }
                    }
                    fileId.push(numbers);
                }
                yearWiseData["content"] = contentArray;
                if (!~yearWiseDataArray.indexOf(yearWiseData)) {
                    yearWiseDataArray.push(yearWiseData);
                }
            }
            _this.fileId = fileId;
            _this.years = years;
            _this.jsonData = jsonData;
            _this.fileName = fileName;
            _this.yearWiseDataArray = yearWiseDataArray;
        });
    }
    return ClinicalUpdatesElementsController;
}());
export default ClinicalUpdatesElementsController;
//# sourceMappingURL=clinical-updates-elements.controller.js.map